import _ from 'lodash'
import common from '@/utils/common'

export default {
  set (context, payload) {
    context.commit(payload)
  },
  setValue (context, payload) {
    context.commit(payload)
  },
  setSearchCondition: (context) => {
    const objArray = {
      // context.state.Point.searchConditions
      'OrderQuantity.searchConditions': {
        key: context.state.OrderQuantity.searchKey,
        dataSource: context.state.OrderQuantity.searchConditions
      },
      'Order.searchConditions': {
        key: context.state.Order.searchKey,
        dataSource: context.state.Order.searchConditions
      },
      'ExtraExport.searchConditions': {
        key: context.state.ExtraExport.searchKey,
        dataSource: context.state.ExtraExport.searchConditions
      },
      'Customer.searchConditions': {
        key: context.state.Customer.searchKey,
        dataSource: context.state.Customer.searchConditions
      },
      'Account.searchConditions': {
        key: context.state.Account.searchKey,
        dataSource: context.state.Account.searchConditions
      },
      'SiteRole.searchConditions': {
        key: context.state.SiteRole.searchKey,
        dataSource: context.state.SiteRole.searchConditions
      },
      'PermissionRole.searchConditions': {
        key: context.state.PermissionRole.searchKey,
        dataSource: context.state.PermissionRole.searchConditions
      },
      'Product.searchConditions': {
        key: context.state.Product.searchKey,
        dataSource: context.state.Product.searchConditions
      },
      'ProductDetail.searchConditions': {
        key: context.state.ProductDetail.searchKey,
        dataSource: context.state.ProductDetail.searchConditions
      },
      'StockAdjustment.searchConditions': {
        key: context.state.StockAdjustment.searchKey,
        dataSource: context.state.StockAdjustment.searchConditions
      },
      'StockMove.searchConditions': {
        key: context.state.StockMove.searchKey,
        dataSource: context.state.StockMove.searchConditions
      },
      'Destination.searchConditions': {
        key: context.state.Destination.searchKey,
        dataSource: context.state.Destination.searchConditions
      },
      'Payment.searchConditions': {
        key: context.state.Payment.searchKey,
        dataSource: context.state.Payment.searchConditions
      },
      'PaymentConvenience.searchConditions': {
        key: context.state.PaymentConvenience.searchKey,
        dataSource: context.state.PaymentConvenience.searchConditions
      },
      'PaymentCarrier.searchConditions': {
        key: context.state.PaymentCarrier.searchKey,
        dataSource: context.state.PaymentCarrier.searchConditions
      },
      'PaymentId.searchConditions': {
        key: context.state.PaymentId.searchKey,
        dataSource: context.state.PaymentId.searchConditions
      },
      'Sales.searchConditions': {
        key: context.state.Sales.searchKey,
        dataSource: context.state.Sales.searchConditions
      },
      'SalesDigital.searchConditions': {
        key: context.state.SalesDigital.searchKey,
        dataSource: context.state.SalesDigital.searchConditions
      },
      'SalesProductPhysical.searchConditions': {
        key: context.state.SalesProductPhysical.searchKey,
        dataSource: context.state.SalesProductPhysical.searchConditions
      },
      'SalesProductDigital.searchConditions': {
        key: context.state.SalesProductDigital.searchKey,
        dataSource: context.state.SalesProductDigital.searchConditions
      },
      'SalesYell.searchConditions': {
        key: context.state.SalesYell.searchKey,
        dataSource: context.state.SalesYell.searchConditions
      },
      'convertedSearchConditions': {
        dataSource: context.state.serchConditions
      },
      'PendingProduct.searchConditions': {
        key: context.state.PendingProduct.searchKey,
        dataSource: context.state.PendingProduct.searchConditions
      }
    }
    Object.keys(objArray).forEach((obj) => {
      const conditions = {}
      context.state.searchConditions.forEach((element) => {
        let storeKey = element.requestKey
        if (obj === 'convertedSearchConditions') {
          if (conditions[element.functionKey] == null) conditions[element.functionKey] = {}
          storeKey = `${element.functionKey}.${element.requestKey}`
        }

        if (obj === 'convertedSearchConditions' || element.functionKey === objArray[obj].key) {
          _.set(conditions, storeKey,
            {
              uuid: element.uuid,
              type: translateSearchConditionType(element.inputType),
              title: element.displayValue,
              property: element.optionKey,
              display: false,
              value: '',
              valueType: element.valueType,
              options: [],
              required: Boolean(element.isRequired),
              precision: element.precision,
              max: element.max,
              min: element.min,
              maxLength: element.maxLength,
              placeholder: element.placeholder,
              isAttribute: element.isAttribute
            })
        }
      })
      context.dispatch({
        type: 'set',
        states: { [obj]: conditions }
      })
    })
    context.dispatch({
      type: 'set',
      states: { 'searchConditions': null }
    })
  },
  /**
   * 一覧用検索条件のマスタをセットします。
   */
  setSearchConditionOptions: (context) => {
    let objArray = _.concat([
      context.state.Order.searchConditions,
      context.state.ExtraExport.searchConditions,
      context.state.Customer.searchConditions,
      context.state.Account.searchConditions,
      context.state.SiteRole.searchConditions,
      context.state.PermissionRole.searchConditions,
      context.state.Point.searchConditions,
      context.state.Product.searchConditions,
      context.state.ProductDetail.searchConditions,
      context.state.StockAlert.searchConditions,
      context.state.EcStock.searchConditions,
      context.state.MailTemplate.searchConditions,
      context.state.StockAdjustment.searchConditions,
      context.state.StockMove.searchConditions,
      context.state.Destination.searchConditions,
      context.state.PendingProduct.searchConditions,
      context.state.Payment.searchConditions,
      context.state.PaymentConvenience.searchConditions,
      context.state.PaymentCarrier.searchConditions,
      context.state.PaymentId.searchConditions,
      context.state.Sales.searchConditions,
      context.state.SalesDigital.searchConditions,
      context.state.SalesProductPhysical.searchConditions,
      context.state.SalesProductDigital.searchConditions,
      context.state.SalesYell.searchConditions,
      context.state.Destination.searchConditions
    ], _.values(context.state.convertedSearchConditions))

    const siteCodes = _.map(context.state.sites, val => val.code)
    objArray.forEach(obj => Object.keys(obj).forEach(key => {
      if (['MultiSelector', 'SingleSelector'].includes(obj[key].type)) {
        if (obj[key].property !== '') {
          if (obj[key].property === 'siteCode') { // サイトマスタの場合
            obj[key].options = context.state.sites
          } else {
            let val = common.getValueByPath(context.state.serviceSiteConfigs, obj[key].property)
            if (val) {
              obj[key].options = _.chain(val)
                .entries()
                .reduce((acc, [code, value]) => {
                  // 共通のサービスサイト設定とサイト毎のサービスサイト設定を同じ階層にする
                  _.forEach(siteCodes, siteCode => {
                    if (siteCode in value) {
                      acc.push({ code: code, name: value[siteCode].abbr, order: value[siteCode].order, siteCode: siteCode })
                    }
                  })
                  if ('abbr' in value && 'order' in value) {
                    acc.push({ code: obj[key].valueType === 1 ? Number(code) : code, name: value.abbr, order: value.order, siteCode: null })
                  }
                  return acc
                }, [])
                .sortBy([val => val.siteCode || '', val => val.order])
                .uniqBy('code')
                .map(val => ({ 'code': val.code, 'name': val.name }))
                .value()
            }
          }
        }
      }
    }))
  }
}

function translateSearchConditionType (type) {
  switch (type) {
    case 1: return 'Input'
    case 2: return 'Number'
    case 3: return 'NumberRange'
    case 4: return 'Date'
    case 5: return 'DateTime'
    case 6: return 'SingleSelector'
    case 7: return 'MultiSelector'
  }
  return ''
}
